import { Controller } from 'libraries/front-end-core/core/Router'
import getUrl from 'libraries/front-end-core/core/url'
import { DOCUMENTS_ALL } from 'constants/controllers'
import Main from './Main'
import Header from './Header'

export default new Controller({
  name: DOCUMENTS_ALL,
  route: 'documents/all',
  controller (Router, { params: { view } }, render) {
    const pageId = getUrl(DOCUMENTS_ALL, { view })
    render(
      { Main, Header },
      {
        view,
        aol: 'corporate'
      },
      {
        searchType: 'precedents',
        className: 'precedents',
        pageId,
        aol: 'corporate',
        showNavigation: true
      }
    )

    return pageId
  }
})
